import ExtCarousel from "./ExtCarousel";
import ExteriorImg from "./ExteriorImg";
import ExteriorImage from "./exterior.jpg"; // Adjust path as needed
import "./Exterior.css";

export default function Exterior() {
  return (
    <div
      className="parallax-container"
      style={{ backgroundImage: `url(${ExteriorImage})` }}
    >
      <div className="content">
        <ExteriorImg />
        <ExtCarousel />
      </div>
    </div>
  );
}
